import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import estilos from './Documentacion.module.css'
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';

import BotonVerArchivosComponent from './BotonesComponent/BotonVerArchivosComponent';
import BotonHistorialComponent from './BotonesComponent/BotonHistorialComponent';
import BotonSustituirComponent from './BotonesComponent/BotonSustituirComponent';
import BotonDocumentoValidoComponent from './BotonesComponent/BotonDocumentoValidoComponent';
import { obtenerTodoHistorialCliente } from '../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';

function DocumentacionDomiciliosComponent(props) {
    let detalleCliente = props?.detalle
    const fechaHoy = moment().format('YYYY-MM-DD')
    const dispatch = useDispatch()

    let rowsDocumentacionDomicilios = []

    for (const i in detalleCliente.archivosgeneralescliente) {

        let alertaFechaVencimiento = ''
        let diasFaltantesVencimiento
        let nameDoc = ''

        if (detalleCliente.archivosgeneralescliente[i].nameid.includes("DGCDF")) nameDoc = 'Comprobante de domicilio fiscal.'
        if (detalleCliente.archivosgeneralescliente[i].nameid.includes("DGCSF")) nameDoc = 'Constancia de situación fiscal.'
        if (nameDoc.length > 0) {

            /*if (detalleCliente?.archivosgeneralescliente?.[i]?.fechafin !== null) {

                diasFaltantesVencimiento = moment(detalleCliente?.archivosgeneralescliente?.[i]?.fechafin.substring(0, 10)).diff(moment(fechaHoy), 'days')

                if (diasFaltantesVencimiento > 5) {
                    alertaFechaVencimiento = 'verde'
                } else if (diasFaltantesVencimiento > 0 && diasFaltantesVencimiento < 6) {
                    alertaFechaVencimiento = 'amarillo'
                } else if (diasFaltantesVencimiento == 0 || diasFaltantesVencimiento < 0) {
                    alertaFechaVencimiento = 'rojo'
                }
            } else {
                alertaFechaVencimiento = 'gris'
            }*/

            rowsDocumentacionDomicilios.push({
                id: uuidv4(),
                observacion: detalleCliente?.archivosgeneralescliente?.[i]?.observaciones,
                fechaInicio: detalleCliente?.archivosgeneralescliente?.[i]?.fechainicio !== null ? detalleCliente?.archivosgeneralescliente?.[i]?.fechainicio.substring(0, 10) : '---',
                fechaTermino: detalleCliente?.archivosgeneralescliente?.[i]?.fechafin !== null ? detalleCliente?.archivosgeneralescliente?.[i]?.fechafin.substring(0, 10) : '---',
                estatus: detalleCliente?.archivosgeneralescliente?.[i]?.estatus !== 'null' ? detalleCliente?.archivosgeneralescliente?.[i]?.fechafin : 'Agregar',
                tabla: 'archivosgeneralescliente', nombreId: 'idarchivosgeneralescliente',
                idSolicitud: detalleCliente.archivosgeneralescliente[i].idarchivosgeneralescliente, nameid: detalleCliente?.archivosgeneralescliente?.[i]?.nameid,
                nameDoc: nameDoc, /*colorAlertaFecha: alertaFechaVencimiento*/
                isDocumentoValido: detalleCliente?.archivosgeneralescliente?.[i]?.isdocumentovalido
            })
        }
    }

    if(rowsDocumentacionDomicilios.length > 1) {
        rowsDocumentacionDomicilios.sort(((a, b) => a.idSolicitud - b.idSolicitud));
    }

    const [openModalSustituir, setOpenModalSustituir] = React.useState(false);
    const [dataSustituir, setDataSustituir] = React.useState([]);

    const columnsDocumentacion = [
        {
            field: 'documentoValido', headerName: '', headerAlign: 'center', width: 40, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {params.row.tabla &&
                        <Fragment>
                            <BotonDocumentoValidoComponent data={params.row} idcliente={detalleCliente.idcliente} />
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'nameDoc', headerName: '', headerAlign: 'center', width: 430, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {params.row.tabla ?
                        <div style={{ width: '100%', textAlign: 'left' }}>
                            <label>{`${params.row.nameDoc}`}</label>
                        </div>
                        :
                        <div style={{ width: '100%', padding: '3%'}}>
                            <label className={`${estilos.divisionDocumentacion}`}>{`${params.row.nameDoc}`}</label>
                        </div>
                    }
                </Fragment>
            )
        },
        {
            field: 'archivo', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <Fragment>
                            <Tooltip title="Ver documento"><BotonVerArchivosComponent tabla={params.row?.tabla} nombreId={params.row?.nombreId} idSolicitud={params.row?.idSolicitud} nameid={params.row?.nameid} /></Tooltip>
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'historial', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <Fragment>
                            <Tooltip title="Ver historial de cambios"><IconButton size="large" onClick={() => { handleModalHistorial(params) }}> <HistoryRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'observacion', headerName: '', headerAlign: 'center', width: 300, sortable: false
        },
    ]

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState([]);
    const [archivo, setArchivo] = React.useState('');

    const handleModalHistorial = async (params) => {
        let data = {}
        if (params.row.tabla === "archivosgeneralescliente") {
            data = { idSolicitud: params.row.idSolicitud, tabla: params.row.tabla }
        } else {
            data = { idSolicitud: params.row.idAnexo, tabla: params.row.tabla }
        }
        let datosObtenidos = await dispatch(obtenerTodoHistorialCliente(data))
        setDataHistorial(datosObtenidos?.payload)
        setArchivo(params?.row?.nameDoc)
        setOpenModalHistorial(true)
    }
    const sustituir = async (params) => {
        setDataSustituir(params.row)
        setOpenModalSustituir(true)
    }

    return (
        <Fragment >
            <div style={{ fontFamily: 'Montserrat', height: '700px' }}>
                {rowsDocumentacionDomicilios.length > 0 &&
                    <div style={{ margin: 0, padding: 0 }}>
                        <h5 style={{ textAlign: 'center', fontWeight: 'bold', color: '#7D9A47' }} >Documentación de domicilios.</h5>
                        <Box sx={{ height: '700px', width: '100%', mt: 2 }}>
                            <DataGrid
                                rows={rowsDocumentacionDomicilios}
                                columns={columnsDocumentacion}
                                rowsPerPageOptions={[50]}
                                headerHeight={0}
                                getRowHeight={() => 'auto'}
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    backgroundColor: 'white',
                                    fontFamily: 'Montserrat',
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#4399A4',
                                        color: 'white',
                                        fontFamily: 'Montserrat',
                                        fontWeight: 'bold',
                                        height: '5px'
                                    },
                                    '& .MuiDataGrid-cell': {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    },
                                }}
                            />
                        </Box>
                    </div>
                }
                {rowsDocumentacionDomicilios.length == 0 &&
                    <div style={{ height: '700px', margin: 0, padding: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h5 style={{ fontWeight: 'bold', color: '#7D9A47' }} >No existe documentación registrada.</h5>
                    </div>
                }
                {openModalHistorial && <BotonHistorialComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} archivo={archivo} />}
                {openModalSustituir && <BotonSustituirComponent setOpenModalSustituir={setOpenModalSustituir} data={dataSustituir} idcliente={detalleCliente?.idcliente} />}
            </div>
        </Fragment>
    )

}

export default DocumentacionDomiciliosComponent